import { OrderAdapterFactory } from "./adapters/OrderAdapterFactory.js";
import { UNIFIED_ORDER_STATUS, UNIFIED_ORDER_STATUS_LEVEL } from "./types/UnifiedOrderTypes.js";

class Order {
  #adapter;
  #data;
  #rawOrder;
  #service;

  constructor(orderData, partnerId, service) {
    this.#adapter = OrderAdapterFactory.getAdapter(partnerId);
    this.#service = service;
    this.#rawOrder = orderData;
    const data = this.#adapter.transformOrder(orderData);
    if (!data) {
      throw new Error("Failed to transform order data");
    }
    this.#data = data;
    Object.assign(this, data);
  }

  async accept(prepTime) {
    try {
      const result = await this.#service.acceptOrder(this.#data.orderId, prepTime);
      if (result) {
        this.#data.orderStatus = UNIFIED_ORDER_STATUS.PREPARING;
        this.#data.orderStatusLevel = UNIFIED_ORDER_STATUS_LEVEL.PREPARING;
        this.cacheOrderStatus();
      }
      return result;
    } catch (error) {
      console.error(`Error accepting order ${this.#data.orderId}:`, error);
      throw error;
    }
  }

  async markReady() {
    try {
      const result = await this.#service.markOrderReady(this.#data.orderId);
      if (result) {
        this.#data.orderStatus = UNIFIED_ORDER_STATUS.READY;
        this.#data.orderStatusLevel = UNIFIED_ORDER_STATUS_LEVEL.READY;
        this.cacheOrderStatus();
      }
      return result;
    } catch (error) {
      console.error(
          `Error marking order ${this.#data.orderId} as ready:`,
          error
      );
      throw error;
    }
  }

  async reject() {
    try {
      const result = await this.#service.rejectOrder(
        this.#data.orderId,
        this.#data.restaurantId
      );
      if (result) {
        this.#data.orderStatus = UNIFIED_ORDER_STATUS.REJECTED;
        this.#data.orderStatusLevel = UNIFIED_ORDER_STATUS_LEVEL.REJECTED;
        this.cacheOrderStatus();
      }
      return result;
    } catch (error) {
      console.error(`Error rejecting order ${this.#data.orderId}:`, error);
      throw error;
    }
  }

  async cacheOrderStatus() {
    try {
      const localOrders = localStorage.getItem(`partnerOrders`);
      if (!localOrders) {
        localStorage.setItem(`partnerOrders`, JSON.stringify({}));
        return;
      }

      const cachedOrder = JSON.parse(localOrders);
      cachedOrder[this.#data.orderId] = this.#data.orderStatusLevel;
      localStorage.setItem(`partnerOrders`, JSON.stringify(cachedOrder));
      return result;
    } catch (error) {
      console.error(
        `Error caching order status for ${this.#data.orderId}:`,
        error
      );
      throw error;
    }
  }

  // Helper method to get transformed unified data
  getUnifiedData() {
    return this.#adapter.transformOrder(this.#data);
  }
}

export default Order;
